import * as React from "react";

import "./style.css";

interface IProps {
  component?: any;
  route?: any;
  user?: any;
}

export default class PublicLayout extends React.Component<IProps, object> {
  public render() {
    const { component: Component } = this.props;

    return (
      <div className="mts-container-light">
        <Component match={this.props.route.match} location={this.props.route.location} />
      </div>
    );
  }
}
